import { Button, Form, Input, InputNumber, Spin, Table } from "antd";
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { createSlots, deleteSlotsByGameId, getSlotsByFranchiseId, updateSlots } from "../../redux/rtk/features/slot/slotSlice";
import { toast } from "react-toastify";
import CrmSearch from "../CRM/CommonUi/CrmSearch";


function AssignSlot({ isSlotsCreated, setIsSlotsCreated, setIsFormChanged, franchiseSettings, selectedGames, setSelectedGames, setCurrent, userId, setUserId }) {
    const { id } = useParams();
    const { isFetchingSlots, isAssigningSlots } = useSelector(state => state.slot);
    const [form] = Form.useForm();
    const dispatch = useDispatch();

    const [gameSlots, setGameSlots] = useState([])
    const [isSavingForm, setIsSavingForm] = useState(false);
    const [isSubmittingForm, setIsSubmittingForm] = useState(false);

    useEffect(() => {
        if (gameSlots.length > 0) form.validateFields()
    }, [gameSlots, form]);

    const onFinish = useCallback(
        async (callback) => {
            try {
                const values = await form.validateFields();
                let updatedSlots = [];
                gameSlots.map(game => {
                    updatedSlots = [...updatedSlots, ...game.slots.map(slot => ({
                        id: slot.id,
                        franchiseId: game.franchiseId,
                        gameId: game.id,
                        slotWeekCost: slot.slotWeekCost,
                        slotWeekEndCost: slot.slotWeekEndCost
                    }))]
                })
                const res = await dispatch(updateSlots(updatedSlots)).unwrap();
                setIsFormChanged({ submitFunction: null, state: false });
                callback();
            } catch (error) {
                // Check if error is a validation error
                if (error?.errorFields) {
                    toast.error("Please fill all the required fields");
                    throw new Error("Please fill all the required fields");
                }
            }
        },
        [gameSlots]
    );
    useEffect(() => {
        let isMounted = true;
        const initializeGames = async () => {
            try {
                // get all slots by franchise id
                const franchiseSlots = await dispatch(getSlotsByFranchiseId(selectedGames?.[0]?.franchiseId)).unwrap();
                const list = franchiseSlots.map((franchiseSlot) => {
                    const gameData = selectedGames.find((game) => game.id === franchiseSlot.gameId)
                    return {
                        ...gameData,
                        slots: franchiseSlot.slots
                    }
                })
                setGameSlots(list)
            } catch (error) {
                toast.error("Error loading slots. Please try again.");
            }
        };

        initializeGames();

        return () => {
            isMounted = false;
        };
    }, []);


    const cellStyle = { padding: "10px", border: "1px solid #ddd", textAlign: "left" };


    // Handle input changes
    const handleInputChange = (gameId, slotId, field, value) => {
        const newGameSlots = gameSlots.map(game => {
            if (game.id == gameId) {
                const newSlots = game.slots.map(slot => {
                    if (slot.id == slotId) {
                        slot[field] = value
                    }
                    return slot
                })
                return { ...game, slots: newSlots }
            }
            return game
        })
        setGameSlots(newGameSlots)
        setIsFormChanged({ submitFunction: onFinish, state: true });
    };

    const columns = [
        {
            title: "Slot ID",
            dataIndex: "slotId",
            key: "slotId",
            width: "10%",
            onCell: () => ({ style: cellStyle })
        },
        {
            title: "Slot Time",
            dataIndex: "slotName",
            key: "slotTime",
            width: "20%",
            onCell: () => ({ style: cellStyle }), render: text => <span>{text}</span>
        },
        {
            title: "Per Person Slot Cost ₹ (Weekdays)",
            dataIndex: "slotWeekCost",
            key: "slotWeekCost",
            onCell: () => ({ style: cellStyle }),
            width: "35%",
            render: (text, record) => (
                <div className='w-full h-full flex justify-center'>
                    <Form.Item
                        style={{ marginBottom: 0, width: "100%" }}
                        className="form-item-alignment w-full m-0"
                        name={`slotWeekCost-${record?.gameId}-${record?.id}`}
                        initialValue={record?.slotWeekCost == "0" ? "" : record?.slotWeekCost}
                        rules={!record?.isweekCost ? [] : [
                            {
                                type: 'number',
                                transform: (value) => Number(value),
                                validator: (_, value) => {
                                    if (!Number.isInteger(value) || value < 1) {
                                        return Promise.reject('Please enter a valid positive number!');
                                    }
                                    return Promise.resolve();
                                }
                            }
                        ]}
                    >
                        <InputNumber
                            controls={false}
                            className="w-full p-1"
                            placeholder="Per Person Slot Week Cost"
                            onChange={(val) => handleInputChange(record?.gameId, record?.id, "slotWeekCost", val)}
                            disabled={!record?.isweekCost}
                        />
                    </Form.Item>
                </div>
            ),

        },
        {
            title: "Per Person Slot Cost ₹ (Weekends)",
            dataIndex: "slotWeekEndCost",
            key: "slotWeekEndCost",
            onCell: () => ({ style: cellStyle }),
            width: "35%",
            render: (text, record) => (
                <div className='w-full h-full flex items-center justify-center'>
                    <Form.Item
                        style={{ marginBottom: 0, width: "100%" }}
                        className="form-item-alignment w-full m-0"
                        name={`slotWeekEndCost-${record?.gameId}-${record?.id}`}
                        initialValue={record?.slotWeekEndCost == "0" ? "" : record?.slotWeekEndCost}
                        rules={!record?.isweekEndCost ? [] : [
                            {
                                type: 'number',
                                transform: (value) => Number(value),
                                validator: (_, value) => {
                                    if (!Number.isInteger(value) || value < 1) {
                                        return Promise.reject('Please enter valid positive number!');
                                    }
                                    return Promise.resolve();
                                }
                            }
                        ]}
                    >
                        <InputNumber
                            controls={false}
                            className="w-full p-1"
                            placeholder="Per Person Slot Week End Cost"
                            onChange={(val) => handleInputChange(record?.gameId, record?.id, "slotWeekEndCost", val)}
                            disabled={!record?.isweekEndCost}
                        />
                    </Form.Item>
                </div>
            ),

        },
    ];

    return (
        <div className='mr-top mb-4 px-6 pb-6 pt-4 ant-card franchise-third-step border-radius-bottom' style={{ maxWidth: "100%" }}>
            {isFetchingSlots ? <Spin size={"medium"} className="flex items-center justify-center min-h-[60vh]" /> :
                <Form
                    form={form}
                >
                    <div className="flex justify-between items-center">
                        <h2 style={{ fontSize: "1.5rem" }} className="text-xl my-3 text-danger hover:text-dangerHover font-semibold">
                            <span className="pb-1 border-b-2 border-danger inline-block w-max">Assign Slots</span>
                        </h2>
                        <div className="hidden md:flex justify-end">
                            <CrmSearch />
                        </div>
                    </div>
                    {gameSlots?.map((game) => (
                        <div key={game.id} className="slot-grid mt-5">
                            <h1 className="text-lg font-bold mb-3">
                                <span className="">Franchise Name : {game.franchiseName}</span>
                                <span className="px-2">||</span>
                                <span className="">Game Name : {game.gameName}</span>
                            </h1>
                            <Table
                                loading={isFetchingSlots}
                                // rowSelection={{ type: 'checkbox', ...getRowSelectionParams(game.id) }}
                                columns={columns}
                                dataSource={game?.slots?.map((slot, index) => ({ ...slot, key: slot.id, slotId: index + 1, gameId: game.id }))}
                                rowKey="key"
                                pagination={false}
                                rowClassName={(record, index) =>
                                    index % 2 === 0 ? "even-row" : "odd-row"
                                }
                            />
                        </div>
                    )
                    )}
                    <div className="flex justify-end gap-3 mt-5">
                        {id && <Form.Item
                            style={{ marginBottom: "10px" }}
                            wrapperCol={{ span: 24 }}
                        >
                            <Button
                                className='btn-primary border-none w-max'
                                size='large'
                                block
                                shape='round'
                                onClick={async () => {
                                    try {
                                        setIsSavingForm(true);
                                        await onFinish(() => {
                                            setIsSavingForm(false);
                                        });
                                        setIsSavingForm(false);
                                    } catch (error) {
                                        console.error("error in saving form :: ", error)
                                    } finally {
                                        setIsSavingForm(false);
                                    }
                                }}
                                loading={isSavingForm}
                                disabled={isSavingForm || isSubmittingForm}
                            >
                                Save
                            </Button>
                        </Form.Item>}

                        <Form.Item
                            style={{ marginBottom: "10px" }}
                            wrapperCol={{ span: 24 }}
                        >
                            <Button
                                className='btn-primary border-none w-max'
                                size='large'
                                block
                                shape='round'
                                loading={isSubmittingForm}
                                disabled={isSubmittingForm || isSavingForm}
                                onClick={async () => {
                                    try {
                                        setIsSubmittingForm(true);
                                        await onFinish(() => {
                                            setCurrent(current => current + 1);
                                            setIsSubmittingForm(false);
                                        });
                                    } catch (error) {
                                        console.error("error in assigning slots :: ", error)
                                    } finally {
                                        setIsSubmittingForm(false);
                                    }
                                }}
                            >
                                Save & Next
                            </Button>
                        </Form.Item>
                    </div>

                </Form>}
        </div>
    );
}

export default AssignSlot